import {
  Switch,
  Case,
  Default,
} from 'react-if';
import {
  ICompanyAddress,
  IStatementColumns,
  IUpdateSenderProfileRequest,
  IUpdateSettingsRequest,
} from 'shared';

import { Divider } from '../../../../../common/Atoms/Divider';
import { Card } from '../../../../../common/Atoms/Card';
import { Spinner } from '../../../Common/Spinner';
import { CardContent } from '../../../../../common/Atoms/CardContent';
import { useGeneralSettingsForm } from '../../../../hooks/useGeneralSettingsForm';
import { SaveAndError } from '../SaveAndError';

import { SafeMode } from './SafeMode';
import { Branding } from './Branding';
import { TagsSettings } from './TagsSettings';
import { OrganisationDetails } from './OrganisationDetails';
import { DangerZone } from './DangerZone';

export type OnChangeFn = (field: keyof IUpdateSettingsRequest, value: boolean | string | ICompanyAddress | number | IStatementColumns | IUpdateSenderProfileRequest[]) => void

export function GeneralSettings() {
  const {
    formData,
    onChange,
    invalids,
    waiting,
    hasUnsavedChanges,
  } = useGeneralSettingsForm();

  return (
    <Card>
      <CardContent>
        <Switch>
          <Case condition={ waiting }>
            <Spinner center/>
          </Case>
          <Default>
            <div className={ `py-6 ` }>
              <SafeMode
                safeModeOn={ !formData.active }
                setSafeModeOn={ onChange }
              />
              <Divider weight={ `light` } />
              <OrganisationDetails
                formData={ formData }
                onChange={ onChange }
                invalids={ invalids }
                hasUnsavedChanges={ hasUnsavedChanges }
              />
              <Branding
                formData={ formData }
                onChange={ onChange }
                invalids={ invalids }
              />
              <Divider weight={ `light` } />
              <TagsSettings />
            </div>
            <SaveAndError
            />
            <Divider weight={ `light` } />
            <DangerZone />
          </Default>
        </Switch>
      </CardContent>
    </Card>
  );
}
